import React from "react";

function FolderIcon() {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" aria-hidden="true">
      <path
        d="M1 3.5C1 2.67 1.67 2 2.5 2H6.17L7.5 3.5H13.5C14.33 3.5 15 4.17 15 5V11.5C15 12.33 14.33 13 13.5 13H2.5C1.67 13 1 12.33 1 11.5V3.5Z"
        fill="#94A3B8"
        stroke="#94A3B8"
        strokeWidth="0.5"
      />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" aria-hidden="true">
      <rect x="1" y="1" width="14" height="10" rx="1.5" stroke="#94A3B8" strokeWidth="1.2" fill="#F8FAFC" />
      <path d="M1.5 2.5L8 7.5L14.5 2.5" stroke="#94A3B8" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
}

function ChartIcon() {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" aria-hidden="true">
      <rect x="1" y="8" width="3" height="5" rx="0.5" fill="#22C55E" />
      <rect x="6" y="5" width="3" height="8" rx="0.5" fill="#EF4444" />
      <rect x="11" y="2" width="3" height="11" rx="0.5" fill="#3B82F6" />
    </svg>
  );
}

function ArrowLeft() {
  return (
    <svg className="sol-visual__arrow sol-visual__arrow--left" viewBox="0 0 80 48" fill="none" aria-hidden="true">
      <path
        d="M40 0V16H68V44"
        stroke="#8354A5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        markerEnd="url(#sol-arrow-down)"
      />
    </svg>
  );
}

function ArrowCenter() {
  return (
    <svg className="sol-visual__arrow sol-visual__arrow--center" viewBox="0 0 40 48" fill="none" aria-hidden="true">
      <path
        d="M20 0V44"
        stroke="#8354A5"
        strokeWidth="1.5"
        strokeLinecap="round"
        markerEnd="url(#sol-arrow-down)"
      />
    </svg>
  );
}

function ArrowRight() {
  return (
    <svg className="sol-visual__arrow sol-visual__arrow--right" viewBox="0 0 80 48" fill="none" aria-hidden="true">
      <path
        d="M40 0V16H12V44"
        stroke="#8354A5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        markerEnd="url(#sol-arrow-down)"
      />
    </svg>
  );
}

export function UnifiedKnowledgeVisual() {
  return (
    <div className="sol-visual sol-visual--unified">
      <svg width="0" height="0" aria-hidden="true">
        <defs>
          <marker
            id="sol-arrow-down"
            markerWidth="8"
            markerHeight="8"
            refX="4"
            refY="7"
            orient="auto"
          >
            <path d="M4 0L7.5 7H0.5L4 0Z" fill="#8354A5" />
          </marker>
        </defs>
      </svg>

      <div className="sol-visual__sources">
        <div className="sol-visual__source">
          <FolderIcon />
          Policy System
        </div>
        <div className="sol-visual__source">
          <MailIcon />
          Claims Email
        </div>
        <div className="sol-visual__source">
          <ChartIcon />
          Legacy CRM
        </div>
      </div>

      <div className="sol-visual__arrows" aria-hidden="true">
        <ArrowLeft />
        <ArrowCenter />
        <ArrowRight />
      </div>

      <div className="sol-visual__result">One search. One shared context.</div>
    </div>
  );
}

export function ExplainableDecisionsVisual() {
  return (
    <div className="sol-visual sol-visual--decisions">
      <div className="sol-visual__decision-top">
        <span>sub_a1d645cf</span>
        <em>UNDER REVIEW</em>
      </div>
      <div className="sol-visual__decision-body">
        <div className="sol-visual__gauge" aria-hidden="true">
          <span className="sol-visual__gauge-ring" />
          <strong>23</strong>
        </div>
        <div className="sol-visual__decision-meta">
          <small>Portfolio risk</small>
          <strong>Low risk</strong>
        </div>
      </div>
      <div className="sol-visual__tags">
        <span>Coverage risk</span>
        <span>Payment risk</span>
        <span>Model confidence</span>
      </div>
    </div>
  );
}

export function FraudRiskVisual() {
  return (
    <div className="sol-visual sol-visual--fraud">
      <div className="sol-visual__claim">
        <span>CLM-4821 — Meridian Logistics</span>
        <em className="is-high">High</em>
      </div>
      <div className="sol-visual__claim">
        <span>CLM-4790 — Harlow &amp; Sons</span>
        <em className="is-medium">Medium</em>
      </div>
      <div className="sol-visual__claim">
        <span>CLM-4763 — Declerq Retail</span>
        <em className="is-low">Low</em>
      </div>
    </div>
  );
}

export function AuditReadyVisual() {
  return (
    <div className="sol-visual sol-visual--audit">
      <div className="sol-visual__log">
        <time>10:42</time>
        <p>
          <strong>M. Reyes</strong> overrode decision — reason: &quot;manual doc verified&quot;
        </p>
      </div>
      <div className="sol-visual__log">
        <time>09:15</time>
        <p>
          <strong>System</strong> flagged CLM-4821 — fraud score 81
        </p>
      </div>
      <div className="sol-visual__log">
        <time>08:03</time>
        <p>
          <strong>A. Cole</strong> approved sub_a1d645cf
        </p>
      </div>
    </div>
  );
}

const VISUALS = {
  unified: UnifiedKnowledgeVisual,
  decisions: ExplainableDecisionsVisual,
  fraud: FraudRiskVisual,
  audit: AuditReadyVisual,
};

export default function SolutionsVisual({ type }) {
  const Component = VISUALS[type];
  return Component ? <Component /> : null;
}
